import { type MetaFunction, json } from "@remix-run/cloudflare";
import { flow, orderBy, shuffle, uniqBy } from "lodash-es";
import {
	type TravelListingLoaderProps,
	getTravelListingComponent,
} from "../components/TravelListing";
import { getPosts, stripPostsForListing } from "../data/travelPosts";
import type { SitemapDataFunction } from "../lib/sitemapUtils";

export const meta: MetaFunction = () => {
	return [{ title: "Travel Blog" }];
};

export const loader = async () => {
	const posts = flow(
		() => getPosts(),
		// Shuffle posts so that we get a random post per country
		// each time the page is loaded.
		(_) => shuffle(_),
		// 1 post per country
		(_) => uniqBy(_, (post) => post.countrySlug),
		// // Sorted by country
		// (_) => sortBy(_, (post) => post.country),
		// Sorted by date // TODO: Undo
		(_) => orderBy(_, (post) => post.date, "desc"),
		// Strip posts for listing
		(_) => stripPostsForListing(_),
	)();

	return json<TravelListingLoaderProps>({
		countrySlug: null,
		townSlug: null,
		posts,
	});
};

export default getTravelListingComponent({
	getPostProps(post) {
		return {
			title: post.country,
			to: `/travel/${post.countrySlug}`,
		};
	},
});

export const sitemap: SitemapDataFunction = () => ({
	pathname: "/travel",
	title: "Travel Blog",
	description: "Photos from around the world.",
	order: 1,
});
